import { defineComponent, openBlock, createElementBlock } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CoopVideoAsset",
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    function handlePlay() {
      emit("metricsClick", {
        linkName: "coopasset_playvideo"
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("video", {
        "data-ui": "coop-video-asset",
        controls: "",
        src: "https://www.rei.com/dam/b4459c3734234f8fb7dfba813d6a9fa0",
        width: "839",
        height: "437",
        onPlay: handlePlay
      }, " Your browser does not support the video tag. ", 32);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=CoopVideoAsset.mjs.map
